import { render, staticRenderFns } from "./DxPlanningProducts.vue?vue&type=template&id=1613b592&"
import script from "./DxPlanningProducts.vue?vue&type=script&lang=js&"
export * from "./DxPlanningProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports